export default __webpack_public_path__ + "static/4-2-artwork-1be303fa1e9411b3f0e1ec4585073630.gif";